module.exports = __webpack_public_path__ + "static/parade-2018-e0b24c7e5da90dae3e244ba2520b6a07.jpg";